import { IContractorHireHistory } from '@ebb-v2/ebb-integration';
import { Component, OnInit, Inject, Input } from '@angular/core';

import {
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

export interface DialogContractorReviewListData {
  contractorHireHistorys: IContractorHireHistory[];
  contractorToReviewId: string;
  contractorToReviewBusinessName: string;
  contractorReviewText: string;
  contractorReviewId: string;
  contractorResponseText?: string;
  contractorResponseDate?: Date;
}
@Component({
  selector: 'ebb-portal-dialog-contractorreviewlist',
  templateUrl: './dialog-contractorreviewlist.component.html'
})
export class DialogContractorReviewListComponent implements OnInit {
  public formContractorReviewList: FormGroup;
  public displayedColumns: string[] = ['bizId', 'action'];
  public dataSourceTable = new MatTableDataSource<IContractorHireHistory>([]);

  constructor(
    public dialogRef: MatDialogRef<DialogContractorReviewListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContractorReviewListData,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.initializeNaming();
  }

  private initializeNaming(): void {
  }

  private initializeForm(): void {
    this.formContractorReviewList = this.fb.group({
    });
    this.dataSourceTable = new MatTableDataSource<IContractorHireHistory>(this.data.contractorHireHistorys);
  }
  
  public onSave(): void {
    this.dialogRef.close(this.data);
  }
  
  public onClickCancel(): void {
    this.dialogRef.close();
  }

  public onSelectContractor(item: any): void {
    const contractor = item;
    this.data.contractorToReviewId =  contractor.contractorid;
    this.data.contractorToReviewBusinessName =  contractor.contractorBusinessName;
    this.data.contractorReviewText = contractor.contractorReview;
    this.data.contractorReviewId = contractor.id;
  this.data.contractorResponseText = contractor.contractorResponse;
  this.data.contractorResponseDate = contractor.contractorResponseDate;
    this.dialogRef.close(this.data);
  }
  
}
